import React from "react";

import { MdOutlineChevronRight } from "react-icons/md";

import Can from "../Can";
import LoadingElevaty from "../LoadingElevaty";
import * as Style from "./style";
import { TQuickAccessCard } from "./types";
import DSButton from "../DSButton";

const QuickAccessCardComponent: React.FC<TQuickAccessCard> = ({
  icon,
  title,
  contentLeft,
  onClickButton,
  loading = true,
  permissionButton,
  dataTestId,
  actions,
}) => {
  return (
    <Style.QuickAccessCardComponentContent>
      {loading ? (
        <Style.QuickAccessCardComponentLoading>
          <LoadingElevaty width="100" />
        </Style.QuickAccessCardComponentLoading>
      ) : (
        <>
          <Style.QuickAccessCardComponentIcon>
            {icon}
          </Style.QuickAccessCardComponentIcon>

          <Style.QuickAccessCardComponentTitle>
            <p>{title}</p>
          </Style.QuickAccessCardComponentTitle>

          <Style.QuickAccessCardComponentSubItems>
            <div className="sub-items__left">{contentLeft}</div>

            <div className={`sub-items__right${actions ? " stacked" : ""}`}>
              {actions || (
                <Can permission={permissionButton}>
                  <DSButton
                    type="button"
                    onClick={onClickButton}
                    buttonText="Contratar novo"
                    icon={<MdOutlineChevronRight />}
                    isIconAfter
                    dataTestId={dataTestId}
                    buttonType="primary"
                  />
                </Can>
              )}
            </div>
          </Style.QuickAccessCardComponentSubItems>
        </>
      )}
    </Style.QuickAccessCardComponentContent>
  );
};

export default QuickAccessCardComponent;
